import React, { useCallback, useState } from 'react'
import HtmlRenderer from 'Utils/htmlRenederer.utils'
import styles from '../Prompt.module.less'
import TooltipContent from './HighlightTooltip'

type PromptHTMLContentPropsType = {
    content: string
    id: string
}

export const PromptHTMLHighlightableContent = (props: PromptHTMLContentPropsType) => {
    const [showPopup, setShowPopup] = useState(false)
    const [popupPosition, setPopupPosition] = useState({ x: 0, y: 0 })
    const [selectedRange, setSelectedRange] = useState<Range | null>(null)
    const [highlightedElement, setHighlightedElement] = useState<HTMLElement | null>(null)

    const handleMouseUp = useCallback(() => {
        const selection = window.getSelection()
        if (selection && selection.rangeCount > 0) {
            const range = selection.getRangeAt(0)
            if (range.collapsed) {
                return
            }
            setSelectedRange(range)
            const rect = range.getBoundingClientRect()
            setPopupPosition({
                x: rect.left,
                y: rect.top - 40,
            })
            setShowPopup(true)
        } else {
            setSelectedRange(null)
        }
    }, [])

    const applyHighlight = useCallback(() => {
        if (selectedRange) {
            const selection = window.getSelection()
            document.designMode = 'on'
            if (selection) {
                selection.removeAllRanges()
                selection.addRange(selectedRange)
                document.execCommand('backColor', false, 'yellow')
            }
            document.designMode = 'off'
            setShowPopup(false)
            setSelectedRange(null)
        }
    }, [selectedRange])

    const handleMouseOver = useCallback(
        (event: React.MouseEvent<HTMLDivElement>) => {
            if (selectedRange) {
                setHighlightedElement(null)
                return
            }
            const target = event.target as HTMLElement
            const computedStyle = window.getComputedStyle(target)
            if (computedStyle.backgroundColor === 'rgb(255, 255, 0)') {
                const rect = target.getBoundingClientRect()
                setPopupPosition({
                    x: rect.left,
                    y: rect.top - 40,
                })
                setHighlightedElement(target)
                setShowPopup(true)
            }
        },
        [selectedRange]
    )

    const removeHighlight = useCallback(() => {
        if (highlightedElement) {
            document.designMode = 'on'
            highlightedElement.style.backgroundColor = ''
            document.designMode = 'off'
            setShowPopup(false)
            setHighlightedElement(null)
        }
    }, [highlightedElement])

    const handleMouseLeave = useCallback(() => {
        setShowPopup(false)
        setHighlightedElement(null)
    }, [])

    const cancelHighlight = useCallback(() => {
        setShowPopup(false)
    }, [])

    return (
        <div
            className={styles['text-content']}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseLeave}
            onMouseOver={handleMouseOver}
            onFocus={() => {}}
            id={props.id}
        >
            <HtmlRenderer htmlContent={props.content} />

            {showPopup && (
                <div
                    className={styles['popup']}
                    style={{ top: popupPosition.y, left: popupPosition.x }}
                >
                    <TooltipContent
                        highlightedElement={highlightedElement}
                        applyHighlight={applyHighlight}
                        removeHighlight={removeHighlight}
                        cancelHighlight={cancelHighlight}
                    />
                </div>
            )}
        </div>
    )
}
